import { Box } from "@mui/material";

import { NavBar, Banner, AboutUs, Brand, Field, Footer } from "./indx";

import "./English.css";
const EnglishPage = () => {
  return (
    <>
      <Box component="div" dir="ltr" className="en-page">
        <NavBar></NavBar>
        <Banner></Banner>
        <AboutUs></AboutUs>
        <Brand></Brand>
        <Field></Field>
        <Footer></Footer>
      </Box>
    </>
  );
};
export default EnglishPage;
